/* Ilexwinkel - frontend interactions (no framework) - build v42 pure-css-reveal */
(function () {
  'use strict';

  // (Lucide CDN removed - caused page hang. Icons via inline SVG in snippet.)

  // ---------- Header scroll shadow ----------
  const header = document.querySelector('.ilex-header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 10) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Mobile menu toggle ----------
  const mobileBtn = document.querySelector('[data-ilex-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-ilex-mobile-menu]');
  if (mobileBtn && mobileMenu) {
    const iconOpen = mobileBtn.querySelector('[data-icon="menu"]');
    const iconClose = mobileBtn.querySelector('[data-icon="close"]');
    const overlay = document.createElement('div');
    overlay.className = 'ilex-mobilemenu__overlay';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);
    const setOpen = (open) => {
      mobileMenu.classList.toggle('is-open', open);
      overlay.classList.toggle('is-open', open);
      mobileBtn.setAttribute('aria-expanded', String(open));
      if (iconOpen && iconClose) {
        iconOpen.style.display = open ? 'none' : '';
        iconClose.style.display = open ? '' : 'none';
      }
    };
    mobileBtn.addEventListener('click', () => {
      setOpen(!mobileMenu.classList.contains('is-open'));
    });
    overlay.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) setOpen(false);
    });
  }

  // ---------- Mobile menu submenu accordion ----------
  document.querySelectorAll('[data-ilex-submenu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const group = btn.closest('[data-ilex-submenu]');
      if (!group) return;
      const open = group.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  // ---------- Mobile carousel progression dots ----------
  document.querySelectorAll('.ilex-carousel-mobile').forEach((track) => {
    const items = Array.from(track.children);
    if (items.length <= 1) return;

    const showDots = !track.hasAttribute('data-ilex-no-dots');
    let buttons = [];

    if (showDots) {
      const dots = document.createElement('div');
      dots.className = 'ilex-carousel-dots';
      dots.setAttribute('role', 'tablist');

      buttons = items.map((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ga naar slide ' + (i + 1));
        if (i === 0) b.classList.add('is-active');
        b.addEventListener('click', () => {
          items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        dots.appendChild(b);
        return b;
      });

      track.after(dots);
    }

    let activeIdx = 0;
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let nearest = 0, minDist = Infinity;
        items.forEach((el, i) => {
          const elCenter = el.offsetLeft + el.offsetWidth / 2;
          const dist = Math.abs(elCenter - center);
          if (dist < minDist) { minDist = dist; nearest = i; }
        });
        activeIdx = nearest;
        if (buttons.length) buttons.forEach((b, i) => b.classList.toggle('is-active', i === nearest));
      });
    }, { passive: true });

    // Autoplay (opt-in via data-ilex-autoplay="<ms>"), mobile only
    const autoplayMs = parseInt(track.dataset.ilexAutoplay || '0', 10);
    if (autoplayMs > 0) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileMQ = window.matchMedia('(max-width: 767px)');
      let timer = null;
      let pauseUntil = 0;

      const tick = () => {
        if (document.hidden) return;
        if (!mobileMQ.matches) return;
        if (Date.now() < pauseUntil) return;
        const next = (activeIdx + 1) % items.length;
        items[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      };
      const start = () => {
        if (reduceMotion.matches || !mobileMQ.matches) return;
        if (timer) return;
        timer = setInterval(tick, autoplayMs);
      };
      const stop = () => {
        if (timer) { clearInterval(timer); timer = null; }
      };
      const pauseForUser = () => { pauseUntil = Date.now() + Math.max(4000, autoplayMs + 1500); };

      track.addEventListener('pointerdown', pauseForUser, { passive: true });
      track.addEventListener('touchstart', pauseForUser, { passive: true });
      track.addEventListener('wheel', pauseForUser, { passive: true });

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { e.isIntersecting ? start() : stop(); });
        }, { threshold: 0.25 });
        io.observe(track);
      } else {
        start();
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop(); else start();
      });
      mobileMQ.addEventListener?.('change', () => { mobileMQ.matches ? start() : stop(); });
      reduceMotion.addEventListener?.('change', () => { reduceMotion.matches ? stop() : start(); });
    }
  });

  // ---------- Search toggle ----------
  const searchEl = document.querySelector('[data-ilex-search]');
  const searchBtn = document.querySelector('[data-ilex-search-toggle]');
  const searchInput = searchEl && searchEl.querySelector('input');
  if (searchEl && searchBtn) {
    const headerEl = document.querySelector('.ilex-header');
    searchBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = searchEl.classList.toggle('is-open');
      headerEl?.classList.toggle('is-search-open', open);
      if (open && searchInput) setTimeout(() => searchInput.focus(), 50);
    });
    document.addEventListener('click', (e) => {
      if (!searchEl.contains(e.target)) {
        searchEl.classList.remove('is-open');
        headerEl?.classList.remove('is-search-open');
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchEl.classList.contains('is-open')) {
        searchEl.classList.remove('is-open');
        headerEl?.classList.remove('is-search-open');
        searchBtn.focus();
      }
    });
  }

  // ---------- Cart drawer ----------
  const drawer = document.querySelector('[data-ilex-drawer]');
  const drawerOpenBtns = document.querySelectorAll('[data-ilex-drawer-open]');
  const drawerCloseBtns = document.querySelectorAll('[data-ilex-drawer-close]');
  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  };
  drawerOpenBtns.forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  drawerCloseBtns.forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  window.ilexOpenDrawer = openDrawer;

  // ---------- Cart API helpers (Shopify /cart.js) ----------
  const fmt = (cents) => new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);

  const fetchCart = async () => {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return await res.json();
    } catch (e) { return null; }
  };

  const updateCartCount = async () => {
    const c = await fetchCart();
    if (!c) return;
    document.querySelectorAll('[data-ilex-cart-count]').forEach((el) => {
      const prev = parseInt(el.textContent, 10) || 0;
      el.textContent = c.item_count;
      el.style.display = c.item_count > 0 ? '' : 'none';
      if (c.item_count !== prev) {
        el.classList.remove('is-pulsing');
        void el.offsetWidth;
        el.classList.add('is-pulsing');
        setTimeout(() => el.classList.remove('is-pulsing'), 600);
      }
    });
  };

  const SHIPPING_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  const SHIPPING_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
  const ensureShippingBar = (el) => {
    let wrap = el.querySelector('.ilex-shipping');
    if (wrap) return { wrap, isNew: false };
    el.innerHTML = `
      <div class="ilex-shipping">
        <span class="ilex-shipping__label"></span>
        <div class="ilex-shipping__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
          <div class="ilex-shipping__track"><div class="ilex-shipping__fill" style="width:0%"></div></div>
          <div class="ilex-shipping__icon" aria-hidden="true">${SHIPPING_TRUCK}</div>
        </div>
      </div>`;
    return { wrap: el.querySelector('.ilex-shipping'), isNew: true };
  };
  const renderShippingBar = (cart) => {
    const el = document.querySelector('[data-ilex-shipping]');
    const drawer = document.querySelector('[data-ilex-drawer]');
    if (!el || !drawer) return;
    const threshold = parseInt(drawer.dataset.ilexShippingThreshold || '0', 10);
    if (!threshold) { el.innerHTML = ''; return; }
    const subtotal = cart?.items_subtotal_price || 0;
    const remaining = Math.max(0, threshold - subtotal);
    const pct = Math.min(100, (subtotal / threshold) * 100);
    const { wrap, isNew } = ensureShippingBar(el);
    const labelEl = wrap.querySelector('.ilex-shipping__label');
    const barEl = wrap.querySelector('.ilex-shipping__bar');
    const fillEl = wrap.querySelector('.ilex-shipping__fill');
    const iconEl = wrap.querySelector('.ilex-shipping__icon');
    const wasReached = wrap.classList.contains('ilex-shipping--reached');
    const isReached = remaining === 0;
    const targetWidth = (isReached ? 100 : pct) + '%';
    barEl.setAttribute('aria-valuenow', String(Math.round(isReached ? 100 : pct)));
    if (isReached) {
      labelEl.innerHTML = '<strong>Gratis verzending</strong>';
      if (!wasReached) {
        wrap.classList.add('ilex-shipping--reached');
        iconEl.innerHTML = SHIPPING_CHECK;
        iconEl.classList.remove('is-celebrating');
        void iconEl.offsetWidth;
        iconEl.classList.add('is-celebrating');
        setTimeout(() => iconEl.classList.remove('is-celebrating'), 700);
      }
    } else {
      labelEl.innerHTML = `Nog <strong>${fmt(remaining)}</strong> tot gratis verzending`;
      if (wasReached) {
        wrap.classList.remove('ilex-shipping--reached');
        iconEl.innerHTML = SHIPPING_TRUCK;
      }
    }
    // Animate width: force browser to paint the previous value, then transition to new value next frame.
    const prevWidth = fillEl.style.width || '0%';
    if (isNew) {
      fillEl.style.width = '0%';
      void fillEl.offsetWidth;
    }
    if (prevWidth !== targetWidth || isNew) {
      requestAnimationFrame(() => {
        fillEl.style.width = targetWidth;
        fillEl.classList.remove('is-pulsing');
        void fillEl.offsetWidth;
        fillEl.classList.add('is-pulsing');
        setTimeout(() => fillEl.classList.remove('is-pulsing'), 1100);
      });
    }
  };

  const renderUpsells = (cart) => {
    const el = document.querySelector('[data-ilex-drawer-upsells]');
    const drawer = document.querySelector('[data-ilex-drawer]');
    if (!el || !drawer) return;
    const items = cart?.items || [];
    const hasPlant = items.some((i) => {
      const type = (i.product_type || '').toLowerCase();
      const handle = (i.handle || '').toLowerCase();
      return type === 'haagplanten' || handle.startsWith('ilex-');
    });
    if (!hasPlant) { el.innerHTML = ''; return; }
    let upsells = [];
    try { upsells = JSON.parse(drawer.dataset.ilexCartUpsells || '[]'); } catch {}
    const inCart = new Set(items.map((i) => i.variant_id));
    const filtered = upsells.filter((u) => !inCart.has(u.id));
    if (!filtered.length) { el.innerHTML = ''; return; }
    el.innerHTML = `
      <div class="ilex-upsells">
        <h3 class="ilex-upsells__title">Vaak samen gekocht</h3>
        ${filtered.map((u) => `
          <div class="ilex-upsells__item" data-ilex-upsell-row data-variant-id="${u.id}">
            <div class="ilex-upsells__img">${u.image ? `<img src="${u.image}" alt="${u.title}">` : ''}</div>
            <div class="ilex-upsells__body">
              <h4>${u.title}</h4>
              <span class="ilex-upsells__price">${fmt(u.price)}</span>
            </div>
            <div class="ilex-upsells__cartwrap">
              <button type="button" class="ilex-upsells__add" data-ilex-upsell-add aria-label="Toevoegen">＋</button>
            </div>
          </div>
        `).join('')}
      </div>
    `;
    // One-click add: + button adds 1 of the variant directly
    el.querySelectorAll('[data-ilex-upsell-row]').forEach((row) => {
      const addBtn = row.querySelector('[data-ilex-upsell-add]');
      if (!addBtn) return;
      addBtn.addEventListener('click', async (e) => {
        e.preventDefault(); e.stopPropagation();
        const id = row.dataset.variantId;
        if (!id) return;
        addBtn.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] })
          });
          const c = await fetchCart();
          renderDrawer(c);
          updateCartCount();
        } finally { addBtn.disabled = false; }
      });
    });
  };

  const _prevLineKeys = new Set();
  const _prevSubtotal = { value: -1 };
  const popEl = (el) => {
    if (!el) return;
    el.classList.remove('is-popping');
    void el.offsetWidth;
    el.classList.add('is-popping');
    setTimeout(() => el.classList.remove('is-popping'), 400);
  };
  const renderDrawer = (cart) => {
    const body = document.querySelector('[data-ilex-drawer-body]');
    const subtotalEl = document.querySelector('[data-ilex-cart-subtotal]');
    if (!body) return;
    renderShippingBar(cart);
    renderUpsells(cart);
    renderDelivery(cart);
    renderPickup(cart);
    renderShipDate(cart);
    if (!cart || cart.item_count === 0) {
      body.innerHTML = '<p style="color:var(--ilex-gray-500);text-align:center;padding:2rem 0">Je winkelwagen is leeg.</p>';
      if (subtotalEl) {
        const newVal = fmt(0);
        if (subtotalEl.textContent !== newVal) { subtotalEl.textContent = newVal; popEl(subtotalEl); }
      }
      _prevLineKeys.clear();
      return;
    }
    body.innerHTML = cart.items.map((item) => `
      <div class="ilex-cartitem" data-line-key="${item.key}">
        <div class="ilex-cartitem__img"><img src="${item.image}" alt="${item.product_title}"></div>
        <div class="ilex-cartitem__body">
          <div>
            <h3 class="ilex-cartitem__title">${item.product_title}</h3>
            ${item.variant_title ? `<p class="ilex-cartitem__variant">${item.variant_title}</p>` : ''}
          </div>
          <div class="ilex-cartitem__row">
            <div class="ilex-qty">
              <button type="button" data-ilex-qty-dec aria-label="Verminder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>
              <input type="number" inputmode="numeric" min="0" value="${item.quantity}" data-ilex-qty-input aria-label="Aantal">
              <button type="button" data-ilex-qty-inc aria-label="Verhoog"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>
            </div>
            <span class="ilex-cartitem__price">${fmt(item.final_line_price)}</span>
          </div>
        </div>
        <button class="ilex-cartitem__remove" data-ilex-qty-remove aria-label="Verwijderen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg></button>
      </div>
    `).join('');
    if (subtotalEl) {
      const newVal = fmt(cart.items_subtotal_price);
      if (subtotalEl.textContent !== newVal) {
        subtotalEl.textContent = newVal;
        if (_prevSubtotal.value !== -1) popEl(subtotalEl);
      }
      _prevSubtotal.value = cart.items_subtotal_price;
    }

    const currentKeys = new Set();
    body.querySelectorAll('.ilex-cartitem').forEach((row) => {
      const k = row.dataset.lineKey;
      currentKeys.add(k);
      if (!_prevLineKeys.has(k) && _prevLineKeys.size > 0) {
        row.classList.add('is-new');
        setTimeout(() => row.classList.remove('is-new'), 500);
      }
    });
    _prevLineKeys.clear();
    currentKeys.forEach((k) => _prevLineKeys.add(k));

    body.querySelectorAll('.ilex-cartitem').forEach((row) => {
      const key = row.dataset.lineKey;
      const line = cart.items.find((i) => i.key === key);
      if (!line) return;
      const qtyInput = row.querySelector('[data-ilex-qty-input]');
      row.querySelector('[data-ilex-qty-dec]')?.addEventListener('click', () => changeQty(key, line.quantity - 1));
      row.querySelector('[data-ilex-qty-inc]')?.addEventListener('click', () => changeQty(key, line.quantity + 1));
      row.querySelector('[data-ilex-qty-remove]')?.addEventListener('click', () => changeQty(key, 0));
      if (qtyInput) {
        qtyInput.addEventListener('change', () => {
          const next = Math.max(0, parseInt(qtyInput.value, 10) || 0);
          if (next === line.quantity) return;
          changeQty(key, next);
        });
        qtyInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); qtyInput.blur(); } });
        qtyInput.addEventListener('focus', () => qtyInput.select());
      }
    });
  };

  const changeQty = async (key, quantity) => {
    const res = await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const cart = await res.json();
    renderDrawer(cart);
    updateCartCount();
  };

  const refreshCart = async () => { renderDrawer(await fetchCart()); };

  // ---------- Delivery method (cart attribute "Levering") ----------
  const DELIVERY_ATTR_KEY = 'Levering';
  const pickupRadioValue = () => {
    const r = document.querySelector('[data-ilex-delivery-input][data-ilex-delivery-method="pickup"]');
    return r ? r.value : '';
  };
  const shipRadioValue = () => {
    const r = document.querySelector('[data-ilex-delivery-input][data-ilex-delivery-method="ship"]');
    return r ? r.value : '';
  };
  const isPickupSelected = (cart) => {
    const stored = cart && cart.attributes ? (cart.attributes[DELIVERY_ATTR_KEY] || '') : '';
    const pickupVal = pickupRadioValue();
    return !!pickupVal && stored === pickupVal;
  };
  const isShipSelected = (cart) => {
    const stored = cart && cart.attributes ? (cart.attributes[DELIVERY_ATTR_KEY] || '') : '';
    const shipVal = shipRadioValue();
    return !!shipVal && stored === shipVal;
  };
  const renderDelivery = (cart) => {
    const wrap = document.querySelector('[data-ilex-delivery]');
    if (!wrap) return;
    const hasItems = cart && cart.item_count > 0;
    wrap.hidden = !hasItems;
    if (!hasItems) return;
    wrap.classList.remove('is-invalid');
    const stored = cart && cart.attributes ? (cart.attributes[DELIVERY_ATTR_KEY] || '') : '';
    wrap.querySelectorAll('[data-ilex-delivery-input]').forEach((r) => { r.checked = r.value === stored; });
  };

  // ---------- Pickup date (cart attribute "Ophaaldatum") ----------
  const PICKUP_ATTR_KEY = 'Ophaaldatum';
  const isoDate = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };
  const formatNlDate = (iso) => {
    if (!iso) return '';
    const [y, m, d] = iso.split('-');
    if (!y || !m || !d) return iso;
    return `${parseInt(d, 10)}-${parseInt(m, 10)}-${y}`;
  };
  const isWeekday = (d) => { const dow = d.getDay(); return dow >= 1 && dow <= 5; };
  // Minimum pickup date = max(today + leadDays, Monday of next week), bumped to a weekday.
  // Today (and any past date) is always blocked.
  const computePickupMin = (leadDays) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dayIso = today.getDay() === 0 ? 7 : today.getDay();
    const daysToNextMonday = 8 - dayIso;
    const nextMonday = new Date(today);
    nextMonday.setDate(today.getDate() + daysToNextMonday);
    const candidate = new Date(today);
    candidate.setDate(today.getDate() + Math.max(1, leadDays));
    let min = candidate > nextMonday ? candidate : nextMonday;
    if (min.getTime() <= today.getTime()) {
      min = new Date(today);
      min.setDate(today.getDate() + 1);
    }
    while (min.getDay() === 0 || min.getDay() === 6) min.setDate(min.getDate() + 1);
    return min;
  };
  const renderPickup = (cart) => {
    const wrap = document.querySelector('[data-ilex-pickup]');
    const input = document.querySelector('[data-ilex-pickup-input]');
    const status = document.querySelector('[data-ilex-pickup-status]');
    if (!wrap || !input) return;
    const hasItems = cart && cart.item_count > 0;
    const showPickup = hasItems && isPickupSelected(cart);
    wrap.hidden = !showPickup;
    if (!showPickup) return;
    const leadDays = Math.max(0, parseInt(input.dataset.ilexPickupLeadDays || '0', 10));
    const minDate = computePickupMin(leadDays);
    input.min = isoDate(minDate);
    const stored = cart && cart.attributes ? (cart.attributes[PICKUP_ATTR_KEY] || '') : '';
    if (stored && input.value !== stored) {
      input.value = stored;
      if (status) {
        status.textContent = `Opgeslagen: ${formatNlDate(stored)}`;
        status.classList.remove('is-error');
        status.classList.add('is-saved');
      }
    } else if (!stored && status) {
      status.textContent = '';
      status.classList.remove('is-saved', 'is-error');
    }
  };
  let pickupSaveTimer = null;
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-ilex-pickup-input]');
    if (!input) return;
    const status = document.querySelector('[data-ilex-pickup-status]');
    const value = input.value;
    input.classList.remove('is-invalid');
    if (status) { status.textContent = ''; status.classList.remove('is-saved', 'is-error'); }
    if (!value) return;
    const todayDate = new Date(); todayDate.setHours(0, 0, 0, 0);
    const todayIsoStr = isoDate(todayDate);
    if (value <= todayIsoStr) {
      input.classList.add('is-invalid');
      if (status) {
        status.textContent = input.min
          ? `Eerst mogelijke ophaaldatum: ${formatNlDate(input.min)}`
          : 'Vandaag is niet mogelijk — kies een latere datum';
        status.classList.add('is-error');
      }
      input.value = '';
      return;
    }
    if (input.min && value < input.min) {
      input.classList.add('is-invalid');
      if (status) {
        status.textContent = `Eerst mogelijke ophaaldatum: ${formatNlDate(input.min)}`;
        status.classList.add('is-error');
      }
      input.value = '';
      return;
    }
    const picked = new Date(value + 'T00:00:00');
    if (!isWeekday(picked)) {
      input.classList.add('is-invalid');
      if (status) {
        status.textContent = 'Ophalen kan alleen op werkdagen (ma t/m vr)';
        status.classList.add('is-error');
      }
      input.value = '';
      return;
    }
    clearTimeout(pickupSaveTimer);
    pickupSaveTimer = setTimeout(async () => {
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [PICKUP_ATTR_KEY]: value } })
        });
        if (!res.ok) throw new Error('update failed');
        if (status) {
          status.textContent = `Opgeslagen: ${formatNlDate(value)}`;
          status.classList.remove('is-error');
          status.classList.add('is-saved');
        }
      } catch (err) {
        console.error('[ilex-pickup] save error', err);
        if (status) {
          status.textContent = 'Opslaan mislukt, probeer opnieuw';
          status.classList.add('is-error');
        }
      }
    }, 250);
  });
  // ---------- Ship date (cart attribute "Bezorgdatum") ----------
  const SHIPDATE_ATTR_KEY = 'Bezorgdatum';
  // Minimum ship date = today + 2 days, then bump past Sunday.
  const computeShipDateMin = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const min = new Date(today);
    min.setDate(today.getDate() + 2);
    while (min.getDay() === 0) min.setDate(min.getDate() + 1);
    return min;
  };
  const renderShipDate = (cart) => {
    const wrap = document.querySelector('[data-ilex-shipdate]');
    const input = document.querySelector('[data-ilex-shipdate-input]');
    const status = document.querySelector('[data-ilex-shipdate-status]');
    if (!wrap || !input) return;
    const hasItems = cart && cart.item_count > 0;
    const showShip = hasItems && isShipSelected(cart);
    wrap.hidden = !showShip;
    if (!showShip) return;
    const minDate = computeShipDateMin();
    input.min = isoDate(minDate);
    const stored = cart && cart.attributes ? (cart.attributes[SHIPDATE_ATTR_KEY] || '') : '';
    if (stored && input.value !== stored) {
      input.value = stored;
      if (status) {
        status.textContent = `Opgeslagen: ${formatNlDate(stored)}`;
        status.classList.remove('is-error');
        status.classList.add('is-saved');
      }
    } else if (!stored && status) {
      status.textContent = '';
      status.classList.remove('is-saved', 'is-error');
    }
  };
  let shipDateSaveTimer = null;
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-ilex-shipdate-input]');
    if (!input) return;
    const status = document.querySelector('[data-ilex-shipdate-status]');
    const value = input.value;
    input.classList.remove('is-invalid');
    if (status) { status.textContent = ''; status.classList.remove('is-saved', 'is-error'); }
    if (!value) return;
    if (input.min && value < input.min) {
      input.classList.add('is-invalid');
      if (status) {
        status.textContent = `Eerst mogelijke bezorgdatum: ${formatNlDate(input.min)}`;
        status.classList.add('is-error');
      }
      input.value = '';
      return;
    }
    const picked = new Date(value + 'T00:00:00');
    if (picked.getDay() === 0) {
      input.classList.add('is-invalid');
      if (status) {
        status.textContent = 'Bezorgen is niet mogelijk op zondag';
        status.classList.add('is-error');
      }
      input.value = '';
      return;
    }
    clearTimeout(shipDateSaveTimer);
    shipDateSaveTimer = setTimeout(async () => {
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [SHIPDATE_ATTR_KEY]: value } })
        });
        if (!res.ok) throw new Error('update failed');
        if (status) {
          status.textContent = `Opgeslagen: ${formatNlDate(value)}`;
          status.classList.remove('is-error');
          status.classList.add('is-saved');
        }
      } catch (err) {
        console.error('[ilex-shipdate] save error', err);
        if (status) {
          status.textContent = 'Opslaan mislukt, probeer opnieuw';
          status.classList.add('is-error');
        }
      }
    }, 250);
  });
  // Save delivery method + toggle pickup/ship date visibility
  document.addEventListener('change', async (e) => {
    const radio = e.target.closest('[data-ilex-delivery-input]');
    if (!radio) return;
    const deliveryWrap = document.querySelector('[data-ilex-delivery]');
    if (deliveryWrap) deliveryWrap.classList.remove('is-invalid');
    const isPickup = radio.dataset.ilexDeliveryMethod === 'pickup';
    const isShip = radio.dataset.ilexDeliveryMethod === 'ship';
    const pickupWrap = document.querySelector('[data-ilex-pickup]');
    const shipWrap = document.querySelector('[data-ilex-shipdate]');
    if (pickupWrap) {
      const wasHidden = pickupWrap.hidden;
      pickupWrap.hidden = !isPickup;
      if (isPickup && wasHidden) {
        requestAnimationFrame(() => {
          pickupWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }
    }
    if (shipWrap) {
      const wasHidden = shipWrap.hidden;
      shipWrap.hidden = !isShip;
      if (isShip && wasHidden) {
        requestAnimationFrame(() => {
          shipWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }
    }
    const attrs = { [DELIVERY_ATTR_KEY]: radio.value };
    if (!isPickup) {
      attrs[PICKUP_ATTR_KEY] = '';
      const pInput = document.querySelector('[data-ilex-pickup-input]');
      if (pInput) { pInput.value = ''; pInput.classList.remove('is-invalid'); }
      const pStatus = document.querySelector('[data-ilex-pickup-status]');
      if (pStatus) { pStatus.textContent = ''; pStatus.classList.remove('is-saved', 'is-error'); }
    }
    if (!isShip) {
      attrs[SHIPDATE_ATTR_KEY] = '';
      const sInput = document.querySelector('[data-ilex-shipdate-input]');
      if (sInput) { sInput.value = ''; sInput.classList.remove('is-invalid'); }
      const sStatus = document.querySelector('[data-ilex-shipdate-status]');
      if (sStatus) { sStatus.textContent = ''; sStatus.classList.remove('is-saved', 'is-error'); }
    }
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
      if (!res.ok) throw new Error('update failed');
      const updated = await res.json();
      renderPickup(updated);
      renderShipDate(updated);
    } catch (err) {
      console.error('[ilex-delivery] save error', err);
    }
  });
  // Block checkout until a delivery method is chosen (and pickup date when required)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ilex-checkout-btn]');
    if (!btn) return;
    const deliveryWrap = document.querySelector('[data-ilex-delivery]');
    if (deliveryWrap && !deliveryWrap.hidden) {
      const chosen = deliveryWrap.querySelector('[data-ilex-delivery-input]:checked');
      if (!chosen) {
        e.preventDefault();
        deliveryWrap.classList.add('is-invalid');
        deliveryWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const firstRadio = deliveryWrap.querySelector('[data-ilex-delivery-input]');
        if (firstRadio) {
          try { firstRadio.focus({ preventScroll: true }); } catch { firstRadio.focus(); }
        }
        return;
      }
      if (chosen.dataset.ilexDeliveryMethod === 'ship') {
        const sInput = document.querySelector('[data-ilex-shipdate-input]');
        const sStatus = document.querySelector('[data-ilex-shipdate-status]');
        const sWrap = document.querySelector('[data-ilex-shipdate]');
        if (sInput && !(sWrap && sWrap.hidden) && !sInput.value) {
          e.preventDefault();
          sInput.classList.add('is-invalid');
          if (sStatus) {
            sStatus.textContent = 'Kies eerst een bezorgdatum';
            sStatus.classList.add('is-error');
          }
          sInput.focus();
          try { sInput.showPicker && sInput.showPicker(); } catch {}
        }
        return;
      }
      if (chosen.dataset.ilexDeliveryMethod !== 'pickup') return;
    }
    const drawerEl = document.querySelector('[data-ilex-drawer]');
    const required = drawerEl && drawerEl.dataset.ilexPickupRequired === '1';
    if (!required) return;
    const input = document.querySelector('[data-ilex-pickup-input]');
    const status = document.querySelector('[data-ilex-pickup-status]');
    const wrap = document.querySelector('[data-ilex-pickup]');
    if (!input || (wrap && wrap.hidden)) return;
    if (!input.value) {
      e.preventDefault();
      input.classList.add('is-invalid');
      if (status) {
        status.textContent = 'Kies eerst een ophaaldatum';
        status.classList.add('is-error');
      }
      input.focus();
      try { input.showPicker && input.showPicker(); } catch {}
    }
  });

  // ---------- Add to cart (product forms + quick-add) ----------
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ilex-add-id]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.ilexAddId;
    const qty = parseInt(btn.dataset.ilexAddQty || '1', 10);
    btn.disabled = true;
    try {
      await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: qty }] })
      });
      await updateCartCount();
      openDrawer();
    } finally { btn.disabled = false; }
  });

  // ---------- Product card inline quantity selector ----------
  document.querySelectorAll('[data-ilex-cartwrap]').forEach((wrap) => {
    const toggle = wrap.querySelector('[data-ilex-cart-toggle]');
    const qtyBox = wrap.querySelector('[data-ilex-qty]');
    const qtyInput = wrap.querySelector('[data-ilex-qty-input]');
    const dec = wrap.querySelector('[data-ilex-qty-dec]');
    const inc = wrap.querySelector('[data-ilex-qty-inc]');
    const confirm = wrap.querySelector('[data-ilex-qty-confirm]');
    if (!toggle || !qtyBox) return;
    qtyBox.removeAttribute('hidden');
    toggle.removeAttribute('hidden');
    const open = () => { wrap.classList.add('is-qty-open'); };
    const close = () => {
      wrap.classList.remove('is-qty-open');
      if (qtyInput) qtyInput.value = '1';
    };
    toggle.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); open(); });
    dec?.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1) - 1); });
    inc?.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); qtyInput.value = parseInt(qtyInput.value || 1) + 1; });
    confirm?.addEventListener('click', async (e) => {
      e.preventDefault(); e.stopPropagation();
      const id = wrap.dataset.variantId;
      const q = Math.max(1, parseInt(qtyInput.value || 1));
      if (!id) return;
      confirm.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: q }] })
        });
        await updateCartCount();
        openDrawer();
        close();
      } finally { confirm.disabled = false; }
    });
    // Close qty box when clicking outside
    document.addEventListener('click', (e) => {
      if (wrap.classList.contains('is-qty-open') && !wrap.contains(e.target)) close();
    });
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"][data-ilex-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    try {
      await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      await updateCartCount();
      openDrawer();
    } finally { if (btn) btn.disabled = false; }
  });

  // Reveal is now pure CSS (see .ilex-reveal in ilex.v2.css).

  // ---------- Blog tag filter pills ----------
  document.querySelectorAll('[data-ilex-filter-pills]').forEach((bar) => {
    const grid = document.querySelector('[data-ilex-blog-grid]');
    if (!grid) return;
    const pills = bar.querySelectorAll('.ilex-filter-pill');
    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        const filter = pill.getAttribute('data-filter');
        pills.forEach((p) => { p.classList.toggle('is-active', p === pill); p.setAttribute('aria-pressed', String(p === pill)); });
        grid.querySelectorAll('.ilex-article-card').forEach((card) => {
          const tag = card.getAttribute('data-tag') || '';
          const match = filter === 'all' || tag === filter;
          card.style.display = match ? '' : 'none';
        });
      });
    });
  });

  // ---------- Article share: copy link + toast ----------
  let toastTimer = null;
  const showToast = (text) => {
    let toast = document.querySelector('.ilex-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ilex-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = text;
    toast.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.classList.remove('is-visible'); }, 2600);
  };

  document.querySelectorAll('[data-ilex-share]').forEach((bar) => {
    const url = bar.getAttribute('data-share-url') || location.href;
    const copyBtn = bar.querySelector('[data-ilex-share-copy]');
    if (!copyBtn) return;
    copyBtn.addEventListener('click', async () => {
      const label = copyBtn.getAttribute('aria-label') || 'Copied';
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          const ta = document.createElement('textarea');
          ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select();
          document.execCommand('copy'); document.body.removeChild(ta);
        }
        const copiedText = document.documentElement.lang && document.documentElement.lang.startsWith('en') ? 'Link copied!' : 'Link gekopieerd!';
        showToast(copiedText);
      } catch (_) { showToast(label); }
    });
  });

  // ---------- FAQ accordion (smooth grid-rows animation) ----------
  document.querySelectorAll('[data-ilex-faq]').forEach((item) => {
    const btn = item.querySelector('[data-ilex-faq-toggle]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  // ---------- Haag calculator wizard ----------
  const wiz = document.querySelector('[data-ilex-wizard]');
  if (wiz) {
    const steps = wiz.querySelectorAll('[data-ilex-step]');
    const panels = wiz.querySelectorAll('[data-ilex-panel]');
    const lines = wiz.querySelectorAll('[data-ilex-line]');
    const metersInput = wiz.querySelector('[data-ilex-meters]');
    const sizeCards = wiz.querySelectorAll('[data-ilex-size]');
    const resultCount = wiz.querySelector('[data-ilex-result-count]');
    const resultPrice = wiz.querySelector('[data-ilex-result-price]');
    const resultLabel = wiz.querySelector('[data-ilex-result-label]');
    const resultImg = wiz.querySelector('[data-ilex-result-img]');
    const nextBtns = wiz.querySelectorAll('[data-ilex-wizard-next]');
    const prevBtns = wiz.querySelectorAll('[data-ilex-wizard-prev]');
    const livePreview = wiz.querySelector('[data-ilex-live-preview]');
    const i18n = {
      plants: wiz.dataset.i18nPlants || 'plants',
      pieces: wiz.dataset.i18nPieces || 'pieces',
      perMeter: wiz.dataset.i18nPerMeter || 'per meter',
      resultLabelPrefix: wiz.dataset.i18nResultLabelPrefix || '',
    };
    let current = 1, selectedSize = null;

    const setStep = (n) => {
      current = n;
      steps.forEach((s, i) => {
        const idx = i + 1;
        s.classList.toggle('is-active', idx === current);
        s.classList.toggle('is-done', idx < current);
      });
      lines.forEach((l, i) => l.classList.toggle('is-done', i + 1 < current));
      panels.forEach((p) => p.classList.toggle('is-active', parseInt(p.dataset.ilexPanel, 10) === current));
      if (current === 3) { renderResult(); updateUpsells(); }
    };

    const renderLive = () => {
      if (!selectedSize || !livePreview) return;
      const m = parseFloat(metersInput?.value) || 0;
      const per = parseInt(selectedSize.dataset.perMeter, 10);
      const count = Math.ceil(m * per);
      livePreview.querySelector('[data-ilex-live-count]').textContent = count;
      livePreview.querySelector('[data-ilex-live-label]').textContent = selectedSize.dataset.label + ' (' + per + ' ' + i18n.perMeter + ')';
      livePreview.style.display = m > 0 ? '' : 'none';
    };

    const renderResult = () => {
      if (!selectedSize) return;
      const m = parseFloat(metersInput?.value) || 0;
      const per = parseInt(selectedSize.dataset.perMeter, 10);
      const price = parseFloat(selectedSize.dataset.price);
      const count = Math.ceil(m * per);
      const total = (count * price).toFixed(2).replace('.', ',');
      if (resultCount) resultCount.innerHTML = count + ' <span class="ilex-wizard__result-unit">' + i18n.pieces + '</span>';
      if (resultPrice) resultPrice.textContent = total;
      if (resultLabel) resultLabel.textContent = (i18n.resultLabelPrefix ? i18n.resultLabelPrefix + ' ' : '') + selectedSize.dataset.label;
      if (resultImg) resultImg.src = selectedSize.dataset.image || '';
    };

    sizeCards.forEach((c) => c.addEventListener('click', () => {
      sizeCards.forEach((x) => x.classList.remove('is-selected'));
      c.classList.add('is-selected');
      selectedSize = c;
      wiz.querySelectorAll('[data-ilex-next-requires="size"]').forEach((b) => { b.disabled = false; });
    }));
    metersInput?.addEventListener('input', () => {
      const m = parseFloat(metersInput.value) || 0;
      wiz.querySelectorAll('[data-ilex-next-requires="meters"]').forEach((b) => b.disabled = m <= 0);
      renderLive();
    });
    const scrollWizardIntoView = () => {
      const headerEl = document.querySelector('.ilex-header');
      const offset = headerEl ? headerEl.getBoundingClientRect().height + 16 : 16;
      const top = wiz.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    };
    nextBtns.forEach((b) => b.addEventListener('click', () => { setStep(Math.min(3, current + 1)); scrollWizardIntoView(); }));
    prevBtns.forEach((b) => b.addEventListener('click', () => { setStep(Math.max(1, current - 1)); scrollWizardIntoView(); }));
    setStep(1);

    // Upsells - calc qty from plant count, update display, add to cart on click
    const upsellCards = wiz.querySelectorAll('[data-ilex-upsell-card]');
    const updateUpsells = () => {
      const m = parseFloat(metersInput?.value) || 0;
      const per = selectedSize ? parseInt(selectedSize.dataset.perMeter, 10) : 0;
      const plantCount = Math.ceil(m * per);
      upsellCards.forEach((card) => {
        const perPlants = parseFloat(card.dataset.perPlants) || 1;
        const qty = Math.max(1, Math.ceil(plantCount / perPlants));
        const qtyEl = card.querySelector('[data-ilex-upsell-qty]');
        const totalEl = card.querySelector('[data-ilex-upsell-total]');
        const priceText = card.querySelector('.ilex-wizard__upsell-price')?.textContent.match(/[\d.,]+/g);
        if (qtyEl) qtyEl.textContent = qty;
        if (totalEl && priceText && priceText.length > 1) {
          const price = parseFloat(priceText[1].replace(',', '.'));
          const total = (qty * price).toFixed(2).replace('.', ',');
          totalEl.textContent = '= ' + total;
        }
        card.dataset.calculatedQty = qty;
      });
    };
    upsellCards.forEach((card) => {
      const btn = card.querySelector('[data-ilex-upsell-add]');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const isSelected = card.classList.toggle('is-selected');
        btn.textContent = isSelected ? btn.dataset.labelAdded : btn.dataset.labelAdd;
      });
    });

    // Add-to-cart from step 3 → adds plants + selected upsells, then opens cart drawer
    const orderBtn = wiz.querySelector('[data-ilex-wizard-order]');
    if (orderBtn) {
      orderBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (!selectedSize) {
          showToast('Kies eerst een maat');
          return;
        }
        const variantId = selectedSize.dataset.variantId;
        if (!variantId) {
          console.error('[ilex-calculator] Geen product gekoppeld aan deze maat. Koppel een product in Theme editor → Bereken je haag → Maat-blok → "Gekoppeld product".');
          showToast('Configuratie ontbreekt, neem contact op via info@ilexwinkel.nl');
          return;
        }
        const m = parseFloat(metersInput?.value) || 0;
        const per = parseInt(selectedSize.dataset.perMeter, 10);
        const qty = Math.ceil(m * per);
        if (qty < 1) {
          showToast('Vul eerst het aantal meter in');
          return;
        }
        const items = [{ id: parseInt(variantId, 10), quantity: qty }];
        upsellCards.forEach((card) => {
          if (!card.classList.contains('is-selected')) return;
          const id = card.dataset.variantId;
          const uqty = parseInt(card.dataset.calculatedQty, 10) || 1;
          if (id) items.push({ id: parseInt(id, 10), quantity: uqty });
        });
        orderBtn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            console.error('[ilex-calculator] /cart/add.js failed', res.status, err);
            showToast(err.description || err.message || 'Toevoegen mislukt, probeer opnieuw');
            return;
          }
          await updateCartCount();
          openDrawer();
        } catch (err) {
          console.error('[ilex-calculator] cart fetch error', err);
          showToast('Verbinding verbroken, probeer opnieuw');
        } finally { orderBtn.disabled = false; }
      });
    }
  }

  updateCartCount();
})();
